module.exports = __webpack_public_path__ + "img/fuison5-detail.16d01ad3.jpg";